var $5809cc9d4e92de73$exports = {};
$5809cc9d4e92de73$exports = {
    "dismiss": `Luk`
};


export {$5809cc9d4e92de73$exports as default};
//# sourceMappingURL=da-DK.mjs.map
